import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
    Box,
    Typography,
    CircularProgress,
    Paper,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Link,
} from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';
import { formatDateTime } from '../../lib/dateFormat';

const CallLogs = () => {
    const [logs, setLogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchLogs = async () => {
        try {
            const res = await axios.get('/api/vapi/call-logs');
            setLogs(res.data);
        } catch (err) {
            setError('Failed to fetch call logs');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchLogs();
    }, []);

    return (
        <Box p={3}>
            <Typography variant="h4" gutterBottom>
                <PhoneIcon sx={{ mr: 1 }} />
                Call Logs
            </Typography>

            {loading && <CircularProgress />}
            {error && <Typography color="error">{error}</Typography>}

            {!loading && !error && (
                <Paper>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Caller ID</TableCell>
                                <TableCell>Type / Status</TableCell>
                                <TableCell>Summary</TableCell>
                                <TableCell>Recording</TableCell>
                                <TableCell align="right">Created At</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {logs.map((log) => (
                                <TableRow key={log.id}>
                                    <TableCell>
                                        {log.destination?.callerId || log.destination?.number || '—'}
                                    </TableCell>

                                    <TableCell>
                                        {log.type ?? '—'} {log.status ? `- ${log.status}` : ''}
                                    </TableCell>

                                    <TableCell sx={{ maxWidth: 300 }}>
                                        {log.analysis?.summary || '—'}
                                    </TableCell>

                                    <TableCell>
                                        {log.artifact?.recordingUrl ? (
                                            <Link
                                                href={log.artifact.recordingUrl}
                                                target="_blank"
                                                rel="noopener"
                                                underline="hover"
                                                color="primary"
                                            >
                                                Listen
                                            </Link>
                                        ) : (
                                            '—'
                                        )}
                                    </TableCell>

                                    <TableCell align="right">
                                        {log.createdAt
                                            ? formatDateTime(log.createdAt)
                                            : '—'}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </Paper>
            )}
        </Box>
    );
};

export default CallLogs;
